export default [
  // 官网 open-app
  {
    path: '/landing-pages/open-app/index',
    name: 'LandingPagesOpenAppIndex',
    component: () => import(/* webpackChunkName: 'LandingPagesOpenAppIndex' */ '@/views/landing-pages/open-app/index.vue'),
  },
  // 电子码单扫码
  {
    path: '/landing-pages/electron-code-sheet/index',
    name: 'LandingPagesElectronCodeSheetIndex',
    component: () => import(/* webpackChunkName: 'LandingPagesElectronCodeSheetIndex' */ '@/views/landing-pages/electron-code-sheet/index.vue'),
  },
];
